import { createSelector, ParametricSelector } from 'reselect';
import get from 'lodash/get';
import { isNumeric } from '../../js/app/react/validators';

export const nullableClientIdSelector = (_, { clientId }) => {
  if (!isNumeric(clientId)) {
    return null;
  }
  return clientId;
};

export const clientIdSelector = (_, { clientId }) => {
  if (!isNumeric(clientId)) {
    throw Error('clientId must be a valid numeric value');
  }
  return clientId;
};
export const stateSelector = state => state;

export const fpIdSelector = createSelector(clientIdSelector, stateSelector, (clientId, state) =>
  get(state, `PlanSelectionNewWhatIfs.${clientId}.selectedPlan.planId`, null),
);

export const selectedPlanNameSelector = createSelector(
  clientIdSelector,
  stateSelector,
  (clientId, state) => get(state, `PlanSelectionNewWhatIfs.${clientId}.selectedPlan.name`, '-'),
);

export const currentPlanNameSelector = createSelector(
  clientIdSelector,
  stateSelector,
  (clientId, state) => {
    const plans = get(state, `PlanSelectionNewWhatIfs.${clientId}.plans`, []).concat(
      get(state, `PlanSelectionNewWhatIfs.${clientId}.selectedPlan`, {}),
    );
    return plans.reduce((acc, current) => {
      if (current.isCurrent) {
        return current.name;
      }
      return acc;
    }, '');
  },
);

export const isCurrentPlanSelectorReact = createSelector(
  [
    (state, props): ParametricSelector<any, any, boolean> => nullableClientIdSelector(state, props),
    state => stateSelector(state),
  ],

  (clientId, state) =>
    get(state, `PlanSelectionNewWhatIfs.${clientId}.selectedPlan.isCurrent`, false),
);

export const isCurrentPlanSelector = (state, props) => {
  return isCurrentPlanSelectorReact(state, props);
};

// TODO: Remove this when finishing the migration to react
window.ADV.util.isCurrentPlanSelector = isCurrentPlanSelector;
